module.exports = __webpack_public_path__ + "resources/img/main04_origin.36856b752db9bc34f3aa55db0270f25f.png";